var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50042 2.14719C6.60305 2.23955 6.61137 2.39762 6.519 2.50025L3.9398 5.36603C3.61496 5.72697 3.065 5.77196 2.68581 5.46861L1.51034 4.52823C1.40252 4.44197 1.38504 4.28465 1.4713 4.17684C1.55755 4.06902 1.71487 4.05154 1.82269 4.13779L2.99816 5.07817C3.17052 5.21606 3.4205 5.19561 3.56816 5.03155L6.14736 2.16577C6.23972 2.06314 6.39779 2.05482 6.50042 2.14719Z",
    fill: "#1A1919",
    stroke: "#1A1919",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.1a4e87d617729babb788e20c31d3ac11.svg";
export { ForwardRef as ReactComponent };